import { render } from "./directLossSale.vue?vue&type=template&id=b8b49a8e"
import script from "./directLossSale.vue?vue&type=script&lang=js"
export * from "./directLossSale.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__